import React from "react";
import { motion } from "framer-motion";

const MobileTabBar = ({ activeTab, onTabChange }) => {
    const tabs = [
        { id: "overview", label: "Overview", icon: "M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6" },
        { id: "itinerary", label: "Itinerary", icon: "M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-3 7h3m-3 4h3m-6-4h.01M9 16h.01" },
        { id: "packing", label: "Packing", icon: "M20 7l-8-4-8 4m16 0l-8 4m8-4v10l-8 4m0-10L4 7m8 4v10M4 7v10l8 4" },
        { id: "expenses", label: "Budget", icon: "M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z" },
        { id: "menu", label: "More", icon: "M4 6h16M4 12h16M4 18h16" } // Can expand for other tabs
    ];

    return (
        <div className="lg:hidden fixed bottom-0 left-0 right-0 bg-white border-t border-gray-100 px-6 py-4 flex justify-between items-center z-50 rounded-t-3xl shadow-[0_-10px_40px_rgba(0,0,0,0.05)] pb-[env(safe-area-inset-bottom,1rem)]">
            {tabs.map((tab) => {
                const isActive = activeTab === tab.id;
                return (
                    <button
                        key={tab.id}
                        onClick={() => onTabChange(tab.id)}
                        className={`flex flex-col items-center justify-center gap-1.5 transition-all text-xs w-16 ${isActive ? "text-[#5b6f00]" : "text-gray-400 hover:text-gray-600"
                            }`}
                    >
                        <div className={`relative p-2 rounded-xl transition-all ${isActive ? "bg-[#5b6f00]/10" : "bg-transparent"}`}>
                            <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={isActive ? "2.5" : "2"} d={tab.icon} />
                            </svg>
                            {isActive && (
                                <motion.div
                                    layoutId="bottom-nav-active"
                                    className="absolute -top-1 right-0 w-2 h-2 bg-[#5b6f00] rounded-full border-2 border-white"
                                />
                            )}
                        </div>
                        <span className={`font-bold tracking-tight text-[10px] ${isActive ? "opacity-100" : "opacity-80"}`}>{tab.label}</span>
                    </button>
                );
            })}
        </div>
    );
};

export default MobileTabBar;
